import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LGPDHero from './components/LGPDHero';
import LGPDSections from './components/LGPDSections';
import SEOHead from '../../components/feature/SEOHead';

const LGPD_SCHEMA = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'Política de Privacidade e LGPD | Neuro Elos',
  description:
    'Política de privacidade da Neuro Elos em conformidade com a Lei Geral de Proteção de Dados (LGPD — Lei nº 13.709/2018). Saiba como seus dados são coletados, utilizados e protegidos.',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'Início', item: 'https://neuroelos.com.br/' },
      { '@type': 'ListItem', position: 2, name: 'Política de Privacidade', item: 'https://neuroelos.com.br/lgpd' },
    ],
  },
  about: {
    '@type': 'Thing',
    name: 'LGPD — Lei Geral de Proteção de Dados',
    description: 'Lei nº 13.709/2018 que regulamenta o tratamento de dados pessoais no Brasil.',
  },
};

export default function LGPDPage() {
  return (
    <div className="min-h-screen bg-cream">
      <SEOHead
        title="Política de Privacidade e LGPD | Neuro Elos São Paulo"
        description="Política de privacidade da Neuro Elos em conformidade com a LGPD (Lei nº 13.709/2018). Saiba como seus dados e os dados do seu filho são coletados, utilizados e protegidos no processo de avaliação neuropsicopedagógica."
        keywords="LGPD, política de privacidade, proteção de dados saúde infantil, lei 13709, dados neuropsicopedagogia"
        ogTitle="Política de Privacidade — Neuro Elos"
        ogDescription="Conformidade total com a LGPD. Seus dados e os dados do seu filho protegidos em cada etapa."
        lastModified="2026-03-28"
        schema={LGPD_SCHEMA}
      />
      <Navbar />
      <main>
        <LGPDHero />
        <LGPDSections />
      </main>
      <Footer />
    </div>
  );
}
